import { RootState } from "../RootReducer";

export const Title = (state: RootState): string => state.breadcrumbs.title;
